import { useTranslation } from 'react-i18next'
import type { PipelineApiError } from '@/lib/api/pipelines.ts'
import { CenteredPanel } from '@/shared/feedback/CenteredPanel.tsx'

export function LoadFailure({ failure }: { failure: PipelineApiError }) {
  const { t } = useTranslation()
  return (
    <CenteredPanel
      title={t('pages.managers.error.title')}
      body={
        failure.kind === 'unauthorized'
          ? t('pages.managers.error.unauthorized')
          : t('pages.managers.error.generic')
      }
      meta={failure.status !== null ? `HTTP ${failure.status} · ${failure.message}` : undefined}
      tone="error"
    />
  )
}
